__turbopack_context__.v({
  "apiFlow": "BtS7yG_apiFlow",
  "capabilities": "BtS7yG_capabilities",
  "capability-left": "BtS7yG_capability-left",
  "capability-line": "BtS7yG_capability-line",
  "capability-right": "BtS7yG_capability-right",
  "capability-symbol": "BtS7yG_capability-symbol",
  "capabilityBridge": "BtS7yG_capabilityBridge",
  "capabilityCard": "BtS7yG_capabilityCard",
  "capabilityDiagram": "BtS7yG_capabilityDiagram",
  "capabilityGlyph": "BtS7yG_capabilityGlyph",
  "close": "BtS7yG_close",
  "codeActions": "BtS7yG_codeActions",
  "confetti": "BtS7yG_confetti",
  "confetti-fall": "BtS7yG_confetti-fall",
  "content": "BtS7yG_content",
  "dialog": "BtS7yG_dialog",
  "faceGlyph": "BtS7yG_faceGlyph",
  "footer": "BtS7yG_footer",
  "footerActions": "BtS7yG_footerActions",
  "guideSection": "BtS7yG_guideSection",
  "guideSections": "BtS7yG_guideSections",
  "integration": "BtS7yG_integration",
  "intro": "BtS7yG_intro",
  "keyName": "BtS7yG_keyName",
  "keySelect": "BtS7yG_keySelect",
  "launcher": "BtS7yG_launcher",
  "notice": "BtS7yG_notice",
  "previewBadge": "BtS7yG_previewBadge",
  "primary": "BtS7yG_primary",
  "secondary": "BtS7yG_secondary",
  "secretActions": "BtS7yG_secretActions",
  "secretInput": "BtS7yG_secretInput",
  "secretLabel": "BtS7yG_secretLabel",
  "stepLabel": "BtS7yG_stepLabel",
  "subtle": "BtS7yG_subtle",
  "topbar": "BtS7yG_topbar",
  "vectorDefinition": "BtS7yG_vectorDefinition",
  "vectorGlyph": "BtS7yG_vectorGlyph",
  "vectorHelp": "BtS7yG_vectorHelp",
  "vectorHelpWrap": "BtS7yG_vectorHelpWrap",
  "vectorQuestion": "BtS7yG_vectorQuestion",
  "vectorTerm": "BtS7yG_vectorTerm",
  "welcomeBrand": "BtS7yG_welcomeBrand",
  "welcomeEmoji": "BtS7yG_welcomeEmoji",
  "welcomeTitle": "BtS7yG_welcomeTitle",
});
